var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "selected-treatments" },
    [
      _c("div", { staticClass: "selected-treatments__header" }, [
        _c(
          "h4",
          {
            staticClass: "selected-treatments__title",
            attrs: { id: "selected-treatments-title" },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.tc("spaSoft.step1.selectedTreatments.title")) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("h5", { staticClass: "selected-treatments__subtitle" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.tc("spaSoft.step1.selectedTreatments.titleRight")) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "selected-treatments__list",
          attrs: { name: "selected-treatments-list", tag: "ol" },
        },
        _vm._l(_vm.currentGuestData.selectedTreatments, function (treatment) {
          return _c("SelectedTreatmentCard", {
            key: treatment.uuid,
            staticClass: "selected-treatments__card",
            attrs: { treatment: treatment },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }